import classNames from "classnames";
import { NOTE_STATUS, NOTE_STATUS_LABELS, type Note } from "@/services/api";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Status = NonNullable<Note["status"]>;

type Props = {
  noteStatus: Status;
};

const getClassName = (status: Status): string => {
  switch (status) {
    case NOTE_STATUS.DONE:
      return "done";
    case NOTE_STATUS.IN_PROGRESS:
      return "in-progress";
    case NOTE_STATUS.TO_DO:
      return "to-do";
    default:
      return "";
  }
};

export const NoteStatusTag: FC<Props> = ({ noteStatus }) => {
  return (
    <div className={classNames(styles.root, styles[getClassName(noteStatus)])}>
      {NOTE_STATUS_LABELS[noteStatus]}
    </div>
  );
};
